import type { IncomingHttpHeaders } from 'http';

/** Redacted client-side in packages/web-bff/src/render/tail/index.ts */
interface State {
    cookies: Record<string, string>;
    headers: IncomingHttpHeaders;
    remoteAddress?: string;
    query: qs.ParsedQs;
    params: any;
    /** `http` */
    protocol: string;
    path: string;
}

const initialState = {} as State;

export default function requestReducer(state = initialState): State {
    return state;
}
